import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import MainLayout from './components/common/MainLayout';
import Dashboard from './components/Dashboard';
import Login from './components/auth/Login';
import VehicleList from './components/vehicles/VehicleList';
import DriverList from './components/drivers/DriverList';
import RouteList from './components/routes/RouteList';
import Trips from './components/trips/Trips';
import Stops from './components/stops/Stops';
import ScheduleXmlCalendar from './components/scheduleXml/ScheduleXmlCalendar';
import ScheduleXmlTemplateList from './components/scheduleXml/ScheduleXmlTemplateList';
import ImportData from './components/import/ImportData';
import Users from './components/Users';
import DatabaseBackup from './components/backup/DatabaseBackup';
import VersionChecker from './components/common/VersionChecker';
import RestoreGuard from './components/common/RestoreGuard';

function App() {
  return (
    <AuthProvider>
      <VersionChecker />
      <RestoreGuard />
      <Router>
        <Routes>
          {/* Login route külön, MainLayout nélkül */}
          <Route path="/login" element={<Login />} />
          
          {/* Fő alkalmazás MainLayout-tal */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="vehicles" element={<VehicleList />} />
            <Route path="drivers" element={<DriverList />} />
            <Route path="routes" element={<RouteList />} />
            <Route path="trips" element={<Trips />} />
            <Route path="stops" element={<Stops />} />
            <Route path="schedule-xml" element={<ScheduleXmlCalendar />} />
            <Route path="schedule-xml/templates" element={<ScheduleXmlTemplateList />} />
            <Route path="import" element={<ImportData />} />
            <Route path="users" element={<Users />} />
            <Route path="database-backup" element={<DatabaseBackup />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
